import script from "./SponsorPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SponsorPage.vue?vue&type=script&setup=true&lang=js"

import "./SponsorPage.vue?vue&type=style&index=0&id=7a3c15f5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a3c15f5"]])

export default __exports__